import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import api from '../../services/api_despesas';
import styles from "./styles.module.css";
import { mask, unMask } from 'remask';
import { GoThumbsdown, GoThumbsup, GoReply } from "react-icons/go";
import { BsFillCheckCircleFill } from "react-icons/bs";
import Swal from 'sweetalert2';

export default function AprovacaoReforma() {

    const [especialidades, setEspecialidades] = useState([]);
    const [checkAll, setCheckAll] = useState(false);
    const [atualizar, setAtualizar] = useState(true);
    const [atualizando, setAtualizando] = useState(false);
    const [modalMotivoOpen, setModalMotivoOpen] = useState(false);
    const [motivo, setMotivo] = useState('');
    const [denyAction, setDenyAction] = useState('');

    const [perfis, setPerfis] = useState({
        items: [
        ],
        selectItem: 0
    });

    const [status, setStatus] = useState({
        items: [
            { id: 0, text: "TODOS" },
            { id: 1, text: "NÃO APROVADOS" },
            { id: 2, text: "APROV. GESTOR" },
            { id: 3, text: "REC. GESTOR" },
            { id: 4, text: "APROV. CON/DIR" },
            { id: 5, text: "DEVOLVIDOS" },
            { id: 6, text: "REC. CON/DIR" },
        ],
        selectItem: 1
    });

    const [empresas, setEmpresas] = useState({
        items: [
            { id: 0, text: "TODOS" },
        ],
        selectItem: 0
    });

    useEffect(() => {
        api.get(`/usuario/getempresas`).then(function (response) {
            if (response.data) {
                const emps = Object.assign([], empresas);
                response.data.empresa_usuario.forEach(emp => {
                    var emppush = {};
                    emppush.id = emp.id;
                    emppush.text = emp.descempresa;
                    emps.items.push(emppush);
                });
                setEmpresas(emps);
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
        });

    }, []);

    useEffect(() => {

        if (atualizar || parseInt(perfis.selectItem) !== 0) {

            setAtualizando(true);

            var status_aut = parseInt(status.selectItem);

            var perfil = parseInt(perfis.selectItem);

            if ((parseInt(perfis.selectItem) === 5 || parseInt(perfis.selectItem) === 6) && parseInt(status.selectItem) === 1) {
                status_aut = 2;
            }

            if (parseInt(perfis.selectItem) === 1 && parseInt(status.selectItem) === 1) {
                status_aut = 1
            }

            api.get(`/reforma/aprovacao?perfil=${perfil}&status_aut=${status_aut}&empresa_id=${empresas.selectItem}`).then(function (response) {
                if (response.data) {
                    setEspecialidades(response.data);
                    console.log('aqui', response.data)
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
                setAtualizar(false);
                setAtualizando(false);
            });
        }
    }, [atualizar, status, perfis, empresas]);

    useEffect(() => {
        api.get(`/usuario/getPerfilByUser`).then(function (response) {
            if (response.data) {
                if (response.data.usuario_perfil) {
                    var itens = [];
                    response.data.usuario_perfil.forEach((perf, index) => {
                        if (parseInt(perf.perfil_id) === 1 || parseInt(perf.perfil_id) === 5 || parseInt(perf.perfil_id) === 6) {
                            var item = { id: perf.perfil_id, text: perf.descricao }
                            itens.push(item);
                        }

                    })
                    var perfs = {};
                    perfs.items = itens;
                    perfs.selectItem = itens.find(p => p.id === 1 || p.id === 5 || p.id === 6).id;
                    setPerfis(perfs);
                }
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
        });

    }, []);

    function handleSelectPerfil(value) {
        const perfs = Object.assign([], perfis);
        perfs.selectItem = value;
        setPerfis(perfs);
    }

    function renderStatusAut(status_aut) {
        switch (status_aut) {

            case 1:
                return ('AGUARDANDO GESTOR');
            case 2:
                return ('AGUARDANDO CON/DIR');

            case 3:
                return ('RECUSADO GESTOR');

            case 4:
                return ('APROVADO CON/DIR');

            case 5:
                return ('DEVOLVIDO');

            case 6:
                return ('RECUSADO CON/DIR');
            default:
                return ('SEM PREVISÕES');
        }
    }

    function handleMaskHours(value) {
        //incrementa 00 ao final do valor para representar os minutos para formatar a hora corretamente
        var v = value + '00';
        const originalValue = unMask(v);
        const maskedValue = mask(originalValue, [
            "9", "99", "99:9", "99:99", "999:99", "9999:99", "99999:99", "999999:99"
        ]);
        return (maskedValue);
    }

    function renderAditivoPrevisao(aditivo_previsao) {
        if (aditivo_previsao === 'A') {
            return 'ADITIVO'
        }
        if (aditivo_previsao === 'P') {
            return 'PREVISÃO'
        }
    }

    function handleCheckDesp(checked, indexespec, indexcomp, indexserv, index) {
        var objEspec = Object.assign([], especialidades);

        var check = (checked ? false : true);

        objEspec[indexespec].compartimentos[indexcomp].servicos[indexserv].despesas[index].checked = check;

        setEspecialidades(objEspec);
    }

    function renderRowDespesas(despesas, indexespec, indexcomp, indexserv, show) {
        if (show) {
            return (
                despesas.map((despesa, index) => {
                    return (
                        <>
                            <div className={styles.gridrowdespreforma} key={'desp' + index}>
                                <div>
                                    <input
                                        type="checkbox"
                                        checked={(despesa.checked ? true : false)}
                                        onChange={() => handleCheckDesp(despesa.checked, indexespec, indexcomp, indexserv, index)}
                                    />
                                </div>
                                <div>{renderAditivoPrevisao(despesa.aditivo_previsao)} - {despesa.tipo_despesa.descricao}</div>
                                <div>{(despesa.valor ? despesa.valor : 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</div>
                                <div></div>
                                <div>{renderStatusAut(despesa.status_aut)}</div>
                            </div>
                        </>
                    )
                })

            )
        }

    }

    function handleClickServ(servico, indexespec, indexcomp, index) {


        //faz uma copia do estado especialidades para fazer as atualizações pois todos os outros objetos são dependencias das especialidades
        var objEspec = Object.assign([], especialidades);

        //esconde todos os outros serviços 
        objEspec[indexespec].compartimentos[indexcomp].servicos.map((serv) => {
            serv.show = 0;
        })

        //exibe/esconde o serviço clicado de acordo com o seu status
        objEspec[indexespec].compartimentos[indexcomp].servicos[index].show = !servico.show;

        //atualiza o estado das especialidades
        setEspecialidades(objEspec);
    }

    function handleCheckAllServ(checked, indexespec, indexcomp, index) {
        var objEspec = Object.assign([], especialidades);

        var check = (checked ? false : true);

        objEspec[indexespec].compartimentos[indexcomp].servicos[index].checked = check;

        objEspec[indexespec].compartimentos[indexcomp].servicos[index].despesas.map((desp) => {
            desp.checked = check;
        })

        setEspecialidades(objEspec);
    }

    function renderRowServicos(servicos, indexespec, indexcomp, show) {
        if (show) {
            return (
                servicos.map((servico, index) => {
                    return (
                        <>
                            <div className={styles.gridrowservreforma} key={'serv' + index}>
                                <div>
                                    <input
                                        type="checkbox"
                                        checked={(servico.checked ? true : false)}
                                        onChange={() => handleCheckAllServ(servico.checked, indexespec, indexcomp, index)}
                                    />
                                </div>
                                <div onClick={() => handleClickServ(servico, indexespec, indexcomp, index)}>{servico.frota.cod_frota} - {servico.descricao}</div>
                                <div onClick={() => handleClickServ(servico, indexespec, indexcomp, index)}>{(servico.valor ? servico.valor : 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</div>
                                <div onClick={() => handleClickServ(servico, indexespec, indexcomp, index)}>{handleMaskHours(servico.qtd_horas)}</div>
                                <div onClick={() => handleClickServ(servico, indexespec, indexcomp, index)}>{renderStatusAut(servico.status_aut)}</div>
                            </div>
                            {renderRowDespesas(servico.despesas, indexespec, indexcomp, index, servico.show)}
                        </>
                    )
                })
            )
        }
    }

    function handleClickComp(compartimento, indexespec, index) {

        //faz uma copia do estado especialidades para fazer as atualizações pois todos os outros objetos são dependencias das especialidades
        var objEspec = Object.assign([], especialidades);


        //oculta todos os outros compartimentos e serviços
        objEspec[indexespec].compartimentos.map((comp) => {
            comp.show = 0;
            comp.servicos.map((serv) => {
                serv.show = 0;
            })
        });

        //exibe/oculta o compartimento clicado conforme seu estado
        objEspec[indexespec].compartimentos[index].show = !compartimento.show;

        //atualiza o estado especialidades
        setEspecialidades(objEspec);

    }

    function handleCheckAllComp(checked, indexespec, index) {

        var objEspec = Object.assign([], especialidades);

        var check = (checked ? false : true);

        objEspec[indexespec].compartimentos[index].checked = check;

        objEspec[indexespec].compartimentos[index].servicos.map((serv) => {
            serv.checked = check;
            serv.despesas.map((desp) => {
                desp.checked = check;
            })
        })

        setEspecialidades(objEspec);
    }

    function renderRowCompartimentos(compartimentos, indexespec, show) {

        if (show) {
            return (
                compartimentos.map((compartimento, index) => {
                    return (
                        <>
                            <div className={styles.gridrowcompreforma} key={'comp' + index}>
                                <div>
                                    <input
                                        type="checkbox"
                                        checked={(compartimento.checked ? true : false)}
                                        onChange={() => handleCheckAllComp(compartimento.checked, indexespec, index)}
                                    />
                                </div>
                                <div onClick={() => handleClickComp(compartimento, indexespec, index)}>{compartimento.descricao}</div>
                                <div onClick={() => handleClickComp(compartimento, indexespec, index)}>{(compartimento.valor ? compartimento.valor : 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</div>
                                <div onClick={() => handleClickComp(compartimento, indexespec, index)}>{handleMaskHours(compartimento.qtd_horas)}</div>
                                <div onClick={() => handleClickComp(compartimento, indexespec, index)}>{renderStatusAut(compartimento.status_aut)}</div>
                            </div>
                            {renderRowServicos(compartimento.servicos, indexespec, index, compartimento.show)}
                        </>
                    )
                })
            )
        }
    }

    function handleClickEspec(especialidade, index) {

        //faz uma copia do estado especialidades para fazer as atualizações pois todos os outros objetos são dependencias das especialidades
        var objEspec = Object.assign([], especialidades);

        //oculta todas outras especialidades /c compartimentos / serviços
        objEspec.forEach((espec) => {
            espec.show = 0;
            espec.compartimentos.map((comp) => {
                comp.show = 0;
                comp.servicos.map((serv) => {
                    serv.show = 0;
                })
            })
        })

        //exibe/oculta somente a especialidade clicada conforme seu estado
        objEspec[index].show = !especialidade.show;

        //atualiza o estado especialidades
        setEspecialidades(objEspec);

    }

    function handleCheckAllEspec(checked, index) {

        var objEspec = Object.assign([], especialidades);

        var check = (checked ? false : true);

        objEspec[index].checked = check;

        objEspec[index].compartimentos.map((comp) => {
            comp.checked = check;
            comp.servicos.map((serv) => {
                serv.checked = check;
                serv.despesas.map((desp) => {
                    desp.checked = check;
                })
            })
        })

        setEspecialidades(objEspec);
    }

    function renderRowEspecialidades() {
        return (
            especialidades.map((especialidade, index) => {
                return (
                    <>
                        <div className={styles.gridrowespecreforma} key={'espec' + index}>
                            <div>
                                <input
                                    type="checkbox"
                                    onChange={() => handleCheckAllEspec(especialidade.checked, index)}
                                    checked={(especialidade.checked ? true : false)}
                                />
                            </div>
                            <div onClick={() => handleClickEspec(especialidade, index)}>{especialidade.descricao}</div>
                            <div onClick={() => handleClickEspec(especialidade, index)}>{(especialidade.valor ? especialidade.valor : 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</div>
                            <div onClick={() => handleClickEspec(especialidade, index)}>{handleMaskHours(especialidade.qtd_horas)}</div>
                            <div onClick={() => handleClickEspec(especialidade, index)}>{renderStatusAut(especialidade.status_aut)}</div>
                        </div>
                        {renderRowCompartimentos(especialidade.compartimentos, index, especialidade.show)}
                    </>
                )
            })
        )
    }

    function handleCheckAll() {

        var objEspec = Object.assign([], especialidades);

        objEspec.map((espec) => {
            espec.checked = !checkAll;
            espec.compartimentos.map((comp) => {
                comp.checked = !checkAll;
                comp.servicos.map((serv) => {
                    serv.checked = !checkAll;
                    serv.despesas.map((desp) => {
                        desp.checked = !checkAll;
                    })
                })
            })
        })

        setEspecialidades(objEspec);

        setCheckAll(!checkAll);
    }

    function handleAprove() {

        var despesas = [];

        especialidades.map((especialidade) => {
            especialidade.compartimentos.map((compartimento) => {
                compartimento.servicos.map((servico) => {
                    servico.despesas.map((despesa) => {
                        if (despesa.checked) {
                            despesas.push(despesa.id)
                        }
                    })
                })
            })
        })

        if (despesas.length <= 0) {
            Swal.fire('NÃO HÁ DESPESAS PARA APROVAR');
            return;
        }

        if (parseInt(perfis.selectItem) === 1) {

            api.post(`/reforma/liberardespesas`, { despesas: despesas }).then(function (response) {
                if (response.data) {
                    Swal.fire('TODAS AS DESPESAS SELECIONADAS FORAM LIBERADAS COM SUCESSO!');
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
                setAtualizar(true);
                setCheckAll(false);
            });
        } else {
            api.post(`/reforma/aprovardespesas`, { despesas: despesas }).then(function (response) {
                if (response.data) {
                    Swal.fire('TODAS AS DESPESAS SELECIONADAS FORAM APROVADAS COM SUCESSO!');
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
                setAtualizar(true);
                setCheckAll(false);
            });
        }

    }

    function handleActionGivBack() {
        setDenyAction(1);
        setModalMotivoOpen(true);
    }

    function handleActionReject() {
        setDenyAction(2);
        setModalMotivoOpen(true);
    }

    function renderBtnManut() {
        if (parseInt(status.selectItem) === 1) {
            return (
                <div className={styles.manutprevisao}>
                    <div
                        className="brn-manut aprove"
                        key={'aprovar'}
                        onClick={() => handleAprove()}
                    >
                        <GoThumbsup size="40" />
                    </div>
                    <div className="brn-manut estorn" key={'estornar'}
                        onClick={() => handleActionGivBack()}
                    ><GoReply size="40" /></div>
                    <div className="brn-manut reject" key={'rejeitar'}
                        onClick={() => handleActionReject()}
                    ><GoThumbsdown size="40" /></div>
                </div >
            )
        } else {
            return (<></>)
        }
    }

    function renderAprovacoes() {
        if (atualizando) {
            <div className={styles.divloading}>
                <div className={styles.loading}></div>
            </div>
        } else {
            return (
                <>
                    <div>
                        <div className={styles.gridespecreforma}>
                            <div><input type="checkbox" onChange={() => handleCheckAll()} checked={(checkAll ? true : false)} /></div>
                            <div className={styles.labelaprovacaoreforma}>DESCRIÇÃO</div>
                            <div className={styles.labelaprovacaoreforma}>VALOR TOTAL</div>
                            <div className={styles.labelaprovacaoreforma}>QTD. HORAS</div>
                            <div className={styles.labelaprovacaoreforma}>STATUS</div>
                        </div>
                        {renderRowEspecialidades()}
                    </div>
                    {renderBtnManut()}
                </>
            )
        }
    }

    function renderFlagPerfil() {
        if (perfis.items.length > 1) {
            return (
                <div className="flag-perfil">
                    <label className="label-perfil">VER COMO: </label>
                    <select
                        className="combo-perfil form-control"
                        value={perfis.selectItem} onChange={(e) => handleSelectPerfil(e.target.value)}
                    >
                        {perfis.items.map((item, index) => (
                            <option key={index} value={item.id}>{item.text}</option>
                        ))}
                    </select>
                </div>
            )
        }
    }

    function handleSelectValue(value, obj) {
        const objselected = Object.assign([], obj);
        objselected.selectItem = value;
        return objselected;
    }

    function fecharModalMotivo() {
        setMotivo('');
        setModalMotivoOpen(false);
    }

    function handleGivBack() {
        var despesas = [];

        especialidades.map((especialidade) => {
            especialidade.compartimentos.map((compartimento) => {
                compartimento.servicos.map((servico) => {
                    servico.despesas.map((despesa) => {
                        if (despesa.checked) {
                            despesas.push(despesa.id)
                        }
                    })
                })
            })
        })

        if (despesas.length <= 0) {
            Swal.fire('NÃO HÁ DESPESAS PARA REPROVAR!');
            return;
        }

        const body = {
            despesas: despesas,
            motivo: motivo
        }

        api.post(`/reforma/devolverrdespesas`, body).then(function (response) {
            if (response.data) {
                Swal.fire('TODAS AS DESPESAS SELECIONADAS FORAM DEVOLVIDAS COM SUCESSO!');
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
            setAtualizar(true);
            setCheckAll(false);
            fecharModalMotivo();
        });
    }

    function handleReject() {
        var despesas = [];

        especialidades.map((especialidade) => {
            especialidade.compartimentos.map((compartimento) => {
                compartimento.servicos.map((servico) => {
                    servico.despesas.map((despesa) => {
                        if (despesa.checked) {
                            despesas.push(despesa.id)
                        }
                    })
                })
            })
        })

        if (despesas.length <= 0) {
            Swal.fire('NÃO HÁ DESPESAS PARA REPROVAR!');
            return;
        }

        var status_aut;
        if (parseInt(perfis.selectItem) === 1) {
            status_aut = 3;
        } else {
            status_aut = 6;
        }

        const body = {
            despesas: despesas,
            status_aut: status_aut,
            motivo: motivo
        }

        api.post(`/reforma/recusardespesas`, body).then(function (response) {
            if (response.data) {
                Swal.fire('TODAS AS DESPESAS SELECIONADAS FORAM REPROVADAS COM SUCESSO!');
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
            setAtualizar(true);
            setCheckAll(false);
            fecharModalMotivo();
        });
    }

    function handleConfirmMotivo() {

        if (motivo === '') {
            Swal.fire('O MOTIVO NÃO PODE FICAR EM BRANCO!');
            return;
        }

        if (denyAction === 1) {
            handleGivBack()
        }
        if (denyAction === 2) {
            handleReject()
        }

    }

    function renderModalMotivo() {
        return (
            <div className={(modalMotivoOpen ? styles.modalEsp : "modal-fechado")}>
                <span className="fechar-modal-previsoes" onClick={() => fecharModalMotivo()}>x</span>
                <div>
                    <h4>MOTIVO</h4>
                </div>
                <input type="text" value={motivo} onChange={(e) => setMotivo(e.target.value)} className={styles.motivoreforma} />
                <div className={styles.divbtnmotivo}>
                    < BsFillCheckCircleFill color="green" size="55" className={styles.btnconfirmmotivo} onClick={() => handleConfirmMotivo()} />
                </div>
            </div>
        )
    }

    return (
        <>
            {renderModalMotivo()}
            <div className="container-lg">
                <Header title="APROVAÇÕES ORÇAMENTO DA REFORMA" />
                {renderFlagPerfil()}
                <div className="content form filtro-projetos">
                    <div className="column-lbl">
                        <label>EMPRESA:</label>
                    </div>
                    <div className="column-text">
                        <select
                            className="col-md-12 combobox  edit form-control column-filtro"
                            id="tipo"
                            value={empresas.selectItem}
                            onChange={(e) => setEmpresas(handleSelectValue(e.target.value, empresas))}
                        >
                            {empresas.items.map((item, index) => (
                                <option key={index} value={item.id}>{item.text}</option>
                            ))}
                        </select>
                    </div>
                    <div className="column-lbl">
                        <label>STATUS:</label>
                    </div>
                    <div className="column-text">
                        <select
                            className="col-md-12 combobox  edit form-control column-filtro"
                            id="tipo"
                            value={status.selectItem}
                            onChange={(e) => setStatus(handleSelectValue(parseInt(e.target.value), status))}
                        >
                            {status.items.map((item, index) => (
                                <option key={index} value={item.id}>{item.text}</option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className={styles.bodyaprovacao}>
                    {renderAprovacoes()}
                    <div className={styles.bordalegenda}>
                        <div>LEGENDA</div>
                        <div className={styles.divlegendaaprov}>
                            <div className={styles.cespec}><b>ESPECIALIDADE</b></div>
                            <div className={styles.ccomp}><b>COMPARTIMENTO</b></div>
                            <div className={styles.cserv}><b>SERVIÇO</b></div>
                            <div className={styles.cdesp}><b>DESPESA</b></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}